import React, { Component } from 'react'
import poo from "../../src/img/pp.jpg"
import {Box,Link } from '@mui/material';
import { Container,Typography,Card,Grid,Divider,TextField,Button} from '@mui/material';
import map2 from "../../src/img/map2.png"



const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/" sx={{fontSize:14,color:'#c7167a',}}>
      Home
    </Link>,
   
    <Typography key="3" color="text.primary" sx={{fontSize:14,color:'#c7167a'}}>
    career
    </Typography>,
  ];

export class Career extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
      Perpus  :"",
      name: "",
      emailid : "",
      mobileno:"",
    
      
    }
    this.handleChange=this.handleChange.bind(this);
  
  }

    
    
    handleChange=(e)=>{
    this.setState({[e.target.name]:e.target.value})
    }
    




  render() {
    return (
      <div>
      <br/>
      <br/>
      <Box sx={{backgroundImage:{xs:`url(${poo})`,sm:`url(${poo})`},width:'100%',display:'flex',height:{xs:200,sm:250,md:310},backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',}}>
      <br/>
      <br/>
      <Box sx={{paddingLeft:{xs:0,sm:3},paddingRight:{xs:0,sm:3},mt:3,width:'100%'}}>
      <Container maxWidth='xl'>
      <Box sx={{background:'rgba(28,68,106,.7)',height:{xs:140,sm:180,md:200}, width:'100%',mt:1,}}>
      <Box sx={{mt:2}}>
      <br/>
       <Typography align='center' sx={{color:'#fff',fontWeight:'900',fontSize:{xs:17,sm:17,md:21},fontFamily:'inherit'}}>JOIN THE VENDOR</Typography>
       <Typography align='center' sx={{color:'#fff',fontWeight:'900',fontSize:{xs:17,sm:17,md:21},fontFamily:'inherit'}}>FINDING PORTAL</Typography>
      </Box>


      <Box sx={{display:'flex',justifyContent:'center',mt:{xs:2,sm:2,md:5}}}>
      <Box sx={{backgroundColor:'#c7167a',height:40,width:150,borderRadius:10,}}>
<Box sx={{display:'flex',justifyContent:'center'}} >
<Box>
<Typography sx={{mt:1,color:'white'}}>JOIN</Typography>
</Box>
</Box>
      </Box>
      </Box>
      </Box>
      </Container>
      </Box> 
 </Box>




 <Box sx={{backgroundImage: `url(${map2})`,minHeight:300,backgroundColor:'#022246 ',opacity:0.9}}>
<Box sx={{paddingLeft:{xs:0,sm:3},paddingRight:{xs:0,sm:3}}}>
 <Container maxWidth='xl'>
 <br/>
 <Grid container spacing={2}>
 <Grid item size={{xs:12,sm:12,md:5}}>
  <Box sx={{mt:{xs:1,sm:1,md:10}}}>
  <Box>
  <Typography align='justify'  sx={{mb:2,fontWeight:'335',fontFamily: 'Roboto Slab',color:'#fff',fontSize:{xs:13,sm:13,md:15,lg:15}}}>
  Come build the future with us!
 </Typography>
  <Typography align='justify'  sx={{mb:2,fontWeight:'335',fontFamily: 'Roboto Slab',color:'#fff',fontSize:{xs:13,sm:13,md:15,lg:15}}}>
  A "technician service portal" is a digital platform designed to streamline and enhance the operations of service technicians, whether they are field service technicians, in-house maintenance personnel, or those supporting external customers. It acts as a central hub for all information and tools a technician needs to efficiently perform their duties, ultimately aiming to improve productivity, customer satisfaction, and overall service delivery.
 </Typography>
  </Box>
  </Box>
 </Grid>
 <Grid item size={{xs:12,sm:12,md:7}}>
 <Box sx={{backgroundColor:'white',height:400,display:'flex',flexDirection:'column',marginLeft:{xs:'0',sm:'0',md:'20%'}}}>
 <Box sx={{display:'flex',flexDirection:'column',marginLeft:{xs:'0',sm:'0',md:'15%',},marginRight:{xs:'0',sm:'0',md:'15%',}}}>
 <br/>
 <Typography align='center' sx={{m:2,fontWeight:'bold',color:'#004285'}}>CONTACT FORM</Typography>
 <TextField value={this.state.Perpus}  onChange={this.handleChange} id="outlined-basic" label="For what purpose you are filling the form" name='Perpus' variant="outlined"  size='small' sx={{m:1,fontSize:10}}/>
<TextField value={this.state.name} onChange={this.handleChange} id="outlined-basic" label="Enter name" name='name' variant="outlined"  size='small' sx={{m:1,fontSize:10}}/>
 <TextField value={this.state.emailid} onChange={this.handleChange} id="outlined-basic" label="Enter email id" name='emailid' variant="outlined"  size='small' sx={{m:1}}/>
 < TextField value={this.state.mobileno} onChange={this.handleChange} id="outlined-basic" label="Enter contact no " name='mobileno' variant="outlined"  size='small' sx={{m:1}}/>
<br/>

{/*
this.state.circle?<Box sx={{display:'flex',justifyContent:'center'}}><CircularProgress size={24} /> </Box>:null
    */}
 <Button variant="contained" sx={{width:200,backgroundColor:'#1d294f',ml:1,mt:1}} onClick={()=>{

if(this.state.mobileno!==""&&this.state.emailid!==""&&this.state.name!=="" && this.state.Perpus!=="")

{

this.addContact()

}else{
alert("All fields are complessary")

}




 }}>Submit</Button>


 
 </Box> 
   



   </Box>
 </Grid>
</Grid>

</Container>
</Box>
<br/>
 </Box>
 
 







      
      </div>
    )
  }
}

export default Career